module.exports = __webpack_public_path__ + "static/media/light_fixture_floor_zku.f74d46c5.png";